module.exports = __webpack_public_path__ + "img/t3.4429305a.png";